const overrides = {
  fonts: {
    roboto: '"Roboto", Arial, "Helvetica Neue", Helvetica, sans-serif',
    interstate: '"Interstate", Arial, "Helvetica Neue", Helvetica, sans-serif',
    opensans: '"Open Sans", "Segoe UI", Tahoma, sans-serif',
  },
  fontSizes: {
    '5xl': '2.125rem',
    '6xl': '2.25rem',
    '7xl': '2.5rem',
    '8xl': '2.75rem',
    '9xl': '2.875rem',
  },
};

export { overrides };
